import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector'; // For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector
import { initReactI18next } from 'react-i18next'; // https://react.i18next.com/latest/using-with-hooks

import { captureHandledError } from './sentry.config';

// Custom Vite-powered backend: bundle JSON as JS chunks
const modules = import.meta.glob('./locales/*/*.json');
const viteBackend = {
  type: 'backend' as const,
  init: () => {
    // No initialization needed for this backend
    return;
  },
  read(
    language: string,
    namespace: string,
    callback: (errorValue: unknown, translations: unknown) => void,
  ) {
    const key = `./locales/${language}/${namespace}.json` as const;
    const loader = modules[key];

    if (!loader) {
      callback(new Error(`Missing locale file: ${key}`), null);

      return;
    }

    loader()
      .then(mod => callback(null, (mod as any).default ?? mod))
      .catch(err => callback(err, null));
  },
};

i18n
  .use(viteBackend as any)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['es', 'pt', 'en'],
    ns: ['common'],
    defaultNS: 'common',
    fallbackLng: ['es', 'pt', 'en'],
    react: {
      useSuspense: true,
    },
  })
  .catch(error => {
    captureHandledError(error, {
      feature: 'i18n',
      action: 'init',
    });

    console.error('Error initializing i18n:', error);
  });

